import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NonHubSpotStatus = () => /*#__PURE__*/_jsx(TFlex, {
  children: /*#__PURE__*/_jsxs(Button, {
    use: "link",
    children: [/*#__PURE__*/_jsx(InfoIcon, {
      "aria-label": "Non-HubSpot Forms"
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.nonHubSpotForms.title"
    })]
  })
});
export default NonHubSpotStatus;